import { HIGHLIGHT_PRE_TAG, HIGHLIGHT_POST_TAG, HITS_PER_PAGE, } from '../constants/index.js';
export function fetchMeilisearchResults({ searchClient, queries, }) {
    return searchClient
        .search(queries.map((searchParameters) => {
        const { params, ...headers } = searchParameters;
        return {
            ...headers,
            params: {
                hitsPerPage: HITS_PER_PAGE,
                highlightPreTag: HIGHLIGHT_PRE_TAG,
                highlightPostTag: HIGHLIGHT_POST_TAG,
                ...params,
            },
        };
    }))
        .then((response) => {
        return response.results.map((result, resultsArrayIndex) => {
            const query = queries[resultsArrayIndex];
            return {
                ...result,
                hits: result.hits.map((hit) => ({
                    ...hit,
                    _highlightResult: Object.entries(hit?._highlightResult || {}).reduce((acc, [field, highlightResult]) => {
                        return {
                            ...acc,
                            // if the field is an array, highlightResult is an array of objects
                            [field]: mapOneOrMany(highlightResult, (highlightResult) => calculateHighlightMetadata(query.query || '', query.params?.highlightPreTag || HIGHLIGHT_PRE_TAG, query.params?.highlightPostTag || HIGHLIGHT_POST_TAG, highlightResult.value)),
                        };
                    }, {}),
                })),
            };
        });
    });
}
/**
 * Calculate the highlight metadata for a given highlight value.
 *
 * @param query - The query string.
 * @param preTag - The pre tag.
 * @param postTag - The post tag.
 * @param highlightValue - The highlight value response from Meilisearch.
 * @returns The highlight metadata.
 */
function calculateHighlightMetadata(query, preTag, postTag, highlightValue) {
    // Extract all highlighted segments
    const highlightRegex = new RegExp(`${preTag}(.*?)${postTag}`, 'g');
    const matches = [];
    let match;
    while ((match = highlightRegex.exec(highlightValue)) !== null) {
        matches.push(match[1]);
    }
    // Remove highlight tags to get the highlighted text without the tags
    const cleanValue = highlightValue.replace(new RegExp(`${preTag}|${postTag}`, 'g'), '');
    // Determine if the entire attribute is highlighted
    // fullyHighlighted = true if cleanValue and the concatenation of all matched segments are identical
    const highlightedText = matches.join('');
    const fullyHighlighted = cleanValue === highlightedText;
    // Determine match level:
    // - 'none' if no matches
    // - 'partial' if some matches but not fully highlighted
    // - 'full' if the highlighted text is the entire field value content
    let matchLevel = 'none';
    if (matches.length > 0) {
        matchLevel = cleanValue.includes(query) ? 'full' : 'partial';
    }
    return {
        value: highlightValue,
        fullyHighlighted,
        matchLevel,
        matchedWords: matches,
    };
}
// Helper to apply a function to a single value or an array of values
function mapOneOrMany(value, mapFn) {
    return Array.isArray(value) ? value.map(mapFn) : mapFn(value);
}
//# sourceMappingURL=fetchMeilisearchResults.js.map